import { render, staticRenderFns } from "./MarketingPreferencesAttributes.vue?vue&type=template&id=361c8207&scoped=true&"
import script from "./MarketingPreferencesAttributes.vue?vue&type=script&lang=js&"
export * from "./MarketingPreferencesAttributes.vue?vue&type=script&lang=js&"
import style0 from "./MarketingPreferencesAttributes.vue?vue&type=style&index=0&id=361c8207&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361c8207",
  null
  
)

export default component.exports